import React from "react"
import { auditShape } from "utils/propTypeShapes"
import TaskLink from "../TaskLink"

const TaskViewedAuditItemDetails = ({ audit }) => {
  const { formSubmissionSlug, task } = audit

  return (
    <div>
      Viewed <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
    </div>
  )
}

TaskViewedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskViewedAuditItemDetails
